var chunkMapping = {
	"17454": [
		95073
	],
	"22366": [
		22366
	],
	"25697": [
		25697
	],
	"28611": [
		28611
	],
	"31136": [
		31136
	],
	"42863": [
		42863
	],
	"60866": [
		60866
	],
	"94263": [
		94263
	]
};
var idToExternalAndNameMapping = {
	"22366": [
		"default",
		"./popup-view/reviewer-ranking",
		55741
	],
	"25697": [
		"default",
		"./PdpReviewTabContent",
		55741
	],
	"28611": [
		"default",
		"./reviewer-ranking",
		55741
	],
	"31136": [
		"default",
		"./withOptionWrappedApolloClientProvider",
		55741
	],
	"42863": [
		"default",
		"./feed",
		55741
	],
	"60866": [
		"default",
		"./popup-view/ranking-criteria",
		55741
	],
	"94263": [
		"default",
		"./popup-view/review-ranking-level-info",
		55741
	],
	"95073": [
		"default",
		"./UserBodyInput",
		55741
	]
};
var idToRemoteMap = {
	"22366": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"25697": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"28611": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"31136": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"42863": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"60866": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"94263": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	],
	"95073": [
		{
			"externalType": "script",
			"name": "zigzag-review",
			"externalModuleId": 55741
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}